import { render, staticRenderFns } from "./ModalShippingMethod.vue?vue&type=template&id=1d0892ec&"
import script from "./ModalShippingMethod.vue?vue&type=script&lang=js&"
export * from "./ModalShippingMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports